module.exports = __webpack_public_path__ + "img/AgroDatari_LOGO_25_colorB.c64d489b.png";